<div id="manageUsers" [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow}">
  <div class="subBlockContent">
    <child-header [title]="title" [showAdd]="hasAdminAccess" titleAdd="New User" (addEvent)="addNewUser()" (closeEvent)="close()"></child-header>
    <div class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper">
        <div class="title blade-title-font">
          {{title}} -->
          <!-- <img *ngIf="hasAdminAccess" class="adduser" src="../images/new_ui/my-account/Group.png"
            (click)="addNewUser()"> -->
          <!-- <div *ngIf="hasAdminAccess" class="basic-icon addnewuser-icon" (click)="addNewUser()"></div>  
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->
            <div class="row filter-wrapper">
            
              <div class="searchInputGroup push-left" style="margin: 20px 20px ! important;">
                <div class="searchIcon">
                  <img src="../../images/new_ui/filter.png">
                </div>
                <div>
                  <input class="searchInput" placeholder="Filter" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'"
                    type="text" [(ngModel)]="filterText" (keyup)="filterUsersList()">
                </div>           
              </div>          
            
              <div>
                <ng-select class="customDropdwon" [items]="accessLevelList" bindValue="value" bindLabel="name" placeholder="Filter"
                  [(ngModel)]="accessLevelModel" (change)="filterAccessLevel($event)" [clearable]="false">
                </ng-select>
              </div>
            
            </div>
      
      <div class="shared-outer-wrapper d-block table-header-allign">
        <table matSort (matSortChange)="sortData($event)" class="white" *ngIf="loadContent">
          <thead>
            <tr class="row">
              <th mat-sort-header="loginName" class="col-4">LOGIN NAME</th>
              <th mat-sort-header="mfaEnabled" class="col-2">MFA ENABLED</th>
              <th mat-sort-header="accessLevel" class="col-4">ACCESS LEVEL</th>
              <th class="col-2"></th>
            </tr>
          </thead>
        </table>
      </div>
      <div *ngIf="loadContent">
      <div class="shared-outer-wrapper d-block child-body">
        <table matSort (matSortChange)="sortData($event)" class="white" >
          <thead hidden="true">
            <tr class="row">
              <th mat-sort-header="loginName" class="col-4">LOGIN NAME</th>
              <th mat-sort-header="mfaEnabled" class="col-2">MFA ENABLED</th>
              <th mat-sort-header="accessLevel" class="col-4">ACCESS LEVEL</th>
              <th class="col-2"></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor=" let element of sortedData 
            | TableFilterMultiple: ['loginName', 'mfaEnabled', 'accessLevel'] : filterText">
            
            <!--   <ng-container *ngFor="let renewal of sortedData | TableFilterMultiple:['out_tenant_name', 'out_stock_code', 'out_stk_description', 'out_qty', 'out_term_start_date', 'out_term_expiry_date'] : searchField"> -->
              <tr class="row">
                <td class="col-4 description">{{element?.loginName}}</td>
                <td class="col-2">
                  <img class="yes-no-icon-size" *ngIf="element?.mfaEnabled == 'E' || element?.mfaEnabled == 'M'" src="../../images/site-icons/yes.svg" 
                  ngbTooltip="MFA Enabled" placement="bottom">
                </td>
                <td class="col-4">
                  <!-- <img src="../images/new_ui/my-account/admin.png" *ngIf="element?.adminAccess == 'Y'">&nbsp;
                  <img src="../images/new_ui/my-account/purchase.png" *ngIf="element?.purchaseAccess == 'Y'">&nbsp;
                  <img src="../images/new_ui/my-account/view.png"> -->
                  <div class="basic-icon adminAccess-icon" *ngIf="element?.adminAccess == 'Y'" ngbTooltip="Admin access"
                  placement="bottom"></div>
                  <div class="basic-icon purchaseAccess-icon" *ngIf="element?.purchaseAccess == 'Y'" ngbTooltip="Purchase access"
                  placement="bottom"></div>
                  <div class="basic-icon viewAccess-icon" ngbTooltip="View access"
                  placement="bottom"></div>
                </td>
                <td class="col-2">
                  <button class="button button-red button-mid margin-t-x10" (click)="manageUser(element)">Manage</button>
                </td>
                <div class="row margin-l-x15">
                  <div class="text-font" *ngIf="element?.firstName || element?.lastName">
                    <span class="light-text">NAME:&nbsp;</span>
                    <span class="text">{{element?.firstName}} {{element?.lastName}}</span><br>
                  </div>
                </div>
              </tr>
            <!-- </ng-container> -->
            </ng-container>

          </tbody>
        </table>
      </div>
      </div>

      <!-- <mat-divider></mat-divider>


      <mat-table [dataSource]="usersListFilter" class="mat-elevation-z8" *ngIf="loadContent">
        <ng-container matColumnDef="loginname">
          <mat-header-cell *matHeaderCellDef> LOGIN NAME </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class="description">{{element?.loginName}}</span>
            <div class="result-info" *ngIf="element?.firstName || element?.lastName">
              <div class="produc-secondary-title-wrapper">
                <span class="light-text">NAME:&nbsp;</span>
                <span>{{element?.firstName}} {{element?.lastName}}</span><br>
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="accesslevel">
          <mat-header-cell *matHeaderCellDef> ACCESS LEVEL </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <img src="../images/new_ui/my-account/admin.png" *ngIf="element?.adminAccess == 'Y'">&nbsp;
            <img src="../images/new_ui/my-account/purchase.png" *ngIf="element?.purchaseAccess == 'Y'">&nbsp;
            <img src="../images/new_ui/my-account/view.png">
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="button">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let element"><button class="button button-red button-mid"
              (click)="manageUser(element)">Manage</button></mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table> -->
    </div>
    <loading-screen *ngIf="!loadContent" backDropWidth='620' [showBlurTable]="false"
      (currentLoadingStatus)="onLoading($event)">
    </loading-screen>
  </div>
</div>
<ng-container #entry>
  <router-outlet></router-outlet>
</ng-container>